module.exports = __webpack_public_path__ + "img/tmp_qrcode.cc3c55d4.png";